import { render } from "./GuestTypeEditor.vue?vue&type=template&id=9a4a6352"
import script from "./GuestTypeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestTypeEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/GuestTypeEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a4a6352"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a4a6352', __exports__)) {
    console.log('reload')
    api.reload('9a4a6352', __exports__)
  }
  
  module.hot.accept("./GuestTypeEditor.vue?vue&type=template&id=9a4a6352", () => {
    console.log('re-render')
    api.rerender('9a4a6352', render)
  })

}


export default __exports__